/**
 * PDP only: ReCharge + Quantity – keep product price and Add to Cart in sync with
 * purchase option (subscription vs one-time) and quantity variant (1–5 bottles).
 * For the featured product section, use featured-product-price.js instead.
 */
(function() {
  'use strict';
  try {
    function formatPrice(amount) {
      if (amount == null || isNaN(amount)) return '';
      return '$' + Number(amount).toFixed(2);
    }
    function parsePrice(text) {
      if (!text) return null;
      var m = String(text).match(/([\d,]+\.?\d*)/);
      return m ? parseFloat(m[1].replace(/,/g, '')) : null;
    }

    function getRechargePrices() {
      var subRadio = document.querySelector('input[name="purchaseOption"][value="subscription"]');
      var oneTimeRadio = document.querySelector('input[name="purchaseOption"][value="onetime"]');
      var subLabel = subRadio && subRadio.closest('label');
      var oneTimeLabel = oneTimeRadio && oneTimeRadio.closest('label');
      var subEl = subLabel && subLabel.querySelector('.price-label');
      var oneEl = oneTimeLabel && oneTimeLabel.querySelector('.price-label');
      if (!subEl || !oneEl) {
        var rcSub = document.querySelector('.rc-radio.subscription-radio .price-label');
        var rcOne = document.querySelector('.rc-radio.onetime-radio .price-label');
        if (rcSub) subEl = rcSub;
        if (rcOne) oneEl = rcOne;
      }
      return {
        sub: subEl ? parsePrice(subEl.textContent) : null,
        oneTime: oneEl ? parsePrice(oneEl.textContent) : null
      };
    }

    function getQuantityVariantData() {
      var radio = document.querySelector('input[name="options[Quantity]"]:checked');
      if (!radio) return null;
      var btn = radio.closest('.radio__button');
      var label = btn ? btn.querySelector('label.radio__label') : (radio.id ? document.querySelector('label[for="' + radio.id + '"]') : null);
      if (!label) return null;
      var qMatch = (radio.value || '').match(/\d+/);
      var quantity = qMatch ? parseInt(qMatch[0], 10) : 1;
      var optionTitle = label.querySelector('.option-title');
      if (!optionTitle) return null;
      var div = optionTitle.querySelector('div');
      if (!div) return null;
      var spans = div.querySelectorAll('span');
      var pricePerBottle = null;
      var priceSpan = null;
      for (var i = 0; i < spans.length; i++) {
        var txt = (spans[i].textContent || '').trim();
        if (txt.indexOf('/bottle') === -1 && txt.indexOf('$') === -1) continue;
        var p = parsePrice(txt);
        if (p != null && p >= 1) { pricePerBottle = p; priceSpan = spans[i]; break; }
      }
      if (pricePerBottle == null) return null;
      var originalPerBottle = priceSpan && priceSpan.getAttribute('data-original-price-per-bottle');
      var oneTimePerBottle = originalPerBottle != null && originalPerBottle !== '' ? parseFloat(originalPerBottle) : pricePerBottle;
      var oneTimeTotal = quantity * oneTimePerBottle;
      return { quantity: quantity, pricePerBottle: pricePerBottle, total: quantity * pricePerBottle, oneTimeTotal: oneTimeTotal };
    }

    function getQuantityDiscountPct(quantity) {
      var pct = { 1: 0, 2: 5, 3: 10, 4: 25, 5: 30 };
      return (quantity >= 1 && quantity <= 5) ? pct[quantity] : 0;
    }

    function runUpdate() {
      try {
        var isSub = false;
        var rechargeChecked = document.querySelector('input[name="purchaseOption"]:checked');
        if (rechargeChecked && (rechargeChecked.value || '').toLowerCase() === 'subscription') {
          isSub = true;
        } else {
          var rcActive = document.querySelector('.rc-radio.rc-radio--active, .rc-widget .rc-option--active');
          if (rcActive && rcActive.classList.contains('subscription-radio')) isSub = true;
        }

        var qData = getQuantityVariantData();
        var recharge = getRechargePrices();
        var displayTotal = null;
        var compareTotal = null;
        var badgeText = 'Subscription • Save 10%';

        if (qData) {
          var oneTimeTotal = qData.oneTimeTotal != null ? qData.oneTimeTotal : qData.total;
          if (isSub) {
            if (qData.quantity === 1 && recharge.sub != null) {
              displayTotal = recharge.sub;
              compareTotal = recharge.oneTime != null ? recharge.oneTime : oneTimeTotal;
            } else {
              displayTotal = oneTimeTotal * 0.9;
              compareTotal = oneTimeTotal;
            }
          } else {
            displayTotal = oneTimeTotal;
            compareTotal = null;
          }
        } else if (rechargeChecked) {
          var label = rechargeChecked.closest('label');
          var priceEl = label && label.querySelector('.price-label');
          var priceText = priceEl ? priceEl.textContent : '';
          displayTotal = parsePrice(priceText);
          if (isSub && recharge.oneTime != null) compareTotal = recharge.oneTime;
          if (isSub && label) {
            var discountEl = label.querySelector('.discount-label');
            if (discountEl) {
              badgeText = discountEl.textContent.replace(/subscribe\s*&\s*save\s*/i, 'Subscription • Save ').trim();
              if (badgeText.toLowerCase().indexOf('one-time') !== -1) badgeText = 'Subscription • Save 10%';
            }
          }
        }

        if (displayTotal == null) return;

        var priceStr = formatPrice(displayTotal);
        var atcText = 'Add to Cart - ' + priceStr;
        var qty = (qData && qData.quantity) ? qData.quantity : 1;
        var totalSavingsPct = getQuantityDiscountPct(qty) + (isSub ? 10 : 0);
        var savingsLine = totalSavingsPct > 0 ? 'Total ' + totalSavingsPct + '% savings' : '';

        document.querySelectorAll('[data-product-price]').forEach(function(el) { el.textContent = priceStr; });
        document.querySelectorAll('[data-add-to-cart-text], .single-add-to-cart-button--text').forEach(function(el) {
          el.textContent = atcText;
          var btn = el.closest('button[type="submit"]');
          if (btn) {
            var line = btn.querySelector('.add-to-cart-savings');
            if (!line) {
              line = document.createElement('div');
              line.className = 'add-to-cart-savings';
              line.style.cssText = 'display:block;font-size:0.85em;margin-top:4px;font-weight:600;width:100%;';
              var guarantee = btn.querySelector('.main-banner--guarantee');
              if (guarantee) btn.insertBefore(line, guarantee);
              else btn.appendChild(line);
            }
            if (savingsLine) {
              line.textContent = savingsLine;
              line.style.display = 'block';
            } else {
              line.style.display = 'none';
            }
          }
        });

        var compareEls = document.querySelectorAll('[data-compare-price]');
        if (isSub && compareTotal != null) {
          var compareStr = formatPrice(compareTotal);
          compareEls.forEach(function(el) { el.textContent = compareStr; el.style.display = ''; el.style.visibility = ''; el.classList.remove('hidden'); });
        } else {
          compareEls.forEach(function(el) { el.textContent = ''; el.style.display = 'none'; el.classList.add('hidden'); });
        }

        document.querySelectorAll('[data-price-off]').forEach(function(off) {
          var typeEl = off.querySelector('[data-price-off-type]');
          if (!typeEl) return;
          if (isSub && badgeText) {
            typeEl.textContent = badgeText;
            off.style.display = '';
            off.classList.remove('hidden');
            off.querySelectorAll('[data-price-off-amount], em').forEach(function(n) { n.style.display = 'none'; });
          } else {
            off.style.display = 'none';
            off.classList.add('hidden');
            off.querySelectorAll('[data-price-off-amount], em').forEach(function(n) { n.style.display = ''; });
          }
        });

        var quantityContainer = document.querySelector('.quantity-radios[data-variant-buttons], .quantity-radios');
        if (quantityContainer) {
          var buttons = quantityContainer.querySelectorAll('.radio__button');
          buttons.forEach(function(btn) {
            var radio = btn.querySelector('input[name="options[Quantity]"]');
            var label = btn.querySelector('label.radio__label');
            if (!radio || !label) return;
            var optionTitle = label.querySelector('.option-title');
            if (!optionTitle) return;
            var div = optionTitle.querySelector('div');
            if (!div) return;
            var spans = div.querySelectorAll('span');
            var priceSpan = spans.length >= 2 ? spans[1] : null;
            if (!priceSpan) return;
            var currentText = priceSpan.textContent || '';
            var original = priceSpan.getAttribute('data-original-price-per-bottle');
            if (original === null || original === '') {
              var parsed = parsePrice(currentText);
              if (parsed != null && parsed > 0) priceSpan.setAttribute('data-original-price-per-bottle', String(parsed));
              original = priceSpan.getAttribute('data-original-price-per-bottle');
            }
            if (original === null || original === '') return;
            var originalNum = parseFloat(original);
            var showPrice = isSub ? originalNum * 0.9 : originalNum;
            priceSpan.textContent = formatPrice(showPrice) + '/bottle';
          });
        }
      } catch (err) {}
    }

    function syncOnce() {
      try {
        if (!document.querySelector('form[action*="cart/add"]')) return;
        runUpdate();
      } catch (err) {}
    }

    function init() {
      try {
        if (!document.querySelector('form[action*="cart/add"]')) return;
        document.addEventListener('change', function(e) {
          var t = e.target;
          if (t && (t.name === 'purchaseOption' || t.name === 'options[Quantity]')) {
            runUpdate();
            setTimeout(runUpdate, 0);
          }
        });
        var form = document.querySelector('form[action*="cart/add"]');
        document.addEventListener('click', function(e) {
          var t = e.target;
          if (!t) return;
          var inRc = t.closest && (t.closest('.rc-radio') || t.closest('.rc-widget'));
          if (inRc) {
            setTimeout(function() { runUpdate(); }, 50);
            setTimeout(function() { runUpdate(); }, 200);
          }
        }, true);
        if (form) {
          form.addEventListener('click', function() { setTimeout(runUpdate, 100); });
        }
        setTimeout(syncOnce, 1200);
        setTimeout(syncOnce, 2500);
        setTimeout(syncOnce, 3500);
      } catch (err) {}
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  } catch (err) {}
})();
